import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, ShieldCheck } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { logError } from "@/lib/log";
import { PROMISES } from "@/data/privacyPromises";

// Shown once to brand-new members, before the welcome tour
export const PrivacyPromiseWelcome = ({ onDone }) => {
  const [busy, setBusy] = useState(false);
  const { refreshUser } = useAuth();
  const finish = async () => {
    setBusy(true);
    try { await api.post("/auth/me/privacy-promise-seen"); await refreshUser(); } catch (e) { logError("Privacy promise ack failed:", e); }
    onDone();
  };
  return (
    <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-end sm:items-center justify-center p-3 sm:p-4" data-testid="privacy-welcome">
      <div className="mm-card w-full max-w-2xl max-h-[92vh] flex flex-col mm-fade-up" role="dialog" aria-label="Our privacy promise">
        <div className="p-6 sm:p-7 pb-3">
          <div className="w-12 h-12 rounded-2xl mm-gradient text-white flex items-center justify-center"><ShieldCheck size={24} /></div>
          <h2 className="text-2xl font-bold mt-4" data-testid="privacy-welcome-title">Before you begin: your feelings stay yours</h2>
          <p className="text-mm-muted text-sm mt-1">Here's our promise to you, in plain words.</p>
        </div>
        <ul className="px-6 sm:px-7 overflow-y-auto grid sm:grid-cols-2 gap-3 pb-2">
          {PROMISES.map(([id, Icon, title, text]) => (
            <li key={id} className="mm-soft rounded-2xl p-3.5 flex gap-3" data-testid={`privacy-welcome-${id}`}>
              <Icon size={18} className="text-mm-primary shrink-0 mt-0.5" />
              <div><div className="font-semibold text-sm">{title}</div><div className="text-xs text-mm-muted mt-0.5 leading-relaxed">{text}</div></div>
            </li>
          ))}
        </ul>
        <div className="p-6 sm:p-7 pt-4 flex flex-col-reverse sm:flex-row gap-3 sm:items-center sm:justify-between border-t">
          <Link to="/privacy-promise" target="_blank" className="text-sm text-mm-primary font-semibold text-center" data-testid="privacy-welcome-read-more">Read the full promise</Link>
          <button onClick={finish} disabled={busy} className="mm-btn" data-testid="privacy-welcome-continue">
            {busy && <Loader2 size={16} className="animate-spin" />}I feel safe, let's go
          </button>
        </div>
      </div>
    </div>
  );
};
